import React from 'react';
import {Link} from '@customink/pigment-react';
import PropTypes from 'prop-types';

const propTypes = {
  type: PropTypes.string
};

export default function MedalliaSurvey({type}) {
  const handleSurveyClick = () => {
    let surveyFormId;
    switch (type) {
      case 'edit':
        surveyFormId = 19737;
        break;
      case 'upload':
        surveyFormId = 36296;
        break;
      default:
        throw new Error('Unknown survey type');
    }
    window.KAMPYLE_ONSITE_SDK?.showForm(surveyFormId);
  };

  return window.KAMPYLE_ONSITE_SDK ? (
    <Link
      button
      onClick={handleSurveyClick}
      className="ndx-medalliaSurveyLink"
      variant="uiTextSmall">
      How would you{' '}
      <strong>
        rate our {type === 'edit' ? 'editing tools' : 'upload experience'}?
      </strong>
    </Link>
  ) : null;
}

MedalliaSurvey.propTypes = propTypes;
